import React, {useState, useEffect} from 'react'
import {Icon, List, Button} from 'semantic-ui-react';
import * as ToplistsActions from '../../../actions/canvas/ToplistsActions';
import {useDispatch, useSelector} from 'react-redux';
import { useFirebase } from 'react-redux-firebase';
import {fg, bg} from '../../../constants/ScheduleColors'

export function Listview(props) {
    let toplists = useSelector(({canvas_toplists}) => canvas_toplists.toplists);
    const selected = useSelector(({canvas_toplists}) => canvas_toplists.selected);

    if(typeof toplists !== 'undefined' && toplists !== null){
        toplists = Object.values(toplists);
        toplists.sort((a, b) => a.name.localeCompare(b.name));
    }

    const dispatch = useDispatch();

    console.log(selected);

    return (
        <List selection divided verticalAlign='middle'>
        {
            (typeof toplists !== 'undefined' && toplists !== null)?
                toplists.map((toplist) => {
                    return (
                        <List.Item active={selected === toplist.id}>
                            {
                                (selected === toplist.id)?
                                    <List.Content floated='right'>
                                        <Button icon onClick={(e) => dispatch(ToplistsActions.edit(toplist.id))}><Icon name="wrench" /></Button>
                                    </List.Content>
                                :null
                            }

                            <List.Content style={{
                                cursor: 'pointer',
                                lineHeight: '2em'
                            }} onClick={(e) => {
                                dispatch(ToplistsActions.select(toplist.id));
                            }}>
                                {
                                    (typeof toplist.updating !== false && toplist.updating)?
                                        <Icon name="spinner" loading />
                                    :
                                        <Icon name="square" style={{
                                            color: bg[toplist.coloridx % bg.length]
                                        }} />
                                }
                                {(typeof toplist.name !== 'undefined' && toplist.name !== null && toplist.name.length)?toplist.name:toplist.id}
                            </List.Content>
                        </List.Item>
                    )
                })
            :null
        }
        </List>
    )
}